export default "__VITE_PUBLIC_ASSET__a1135db1__"